import React, { useEffect, useState } from 'react';
import PlatformSelect from '../PlatformSelect';
import type { PlatformGameListType } from '../../types';
import { platformOptions } from '../../constants/platform';
import GameListSelect from '../GameListSelect';
import './index.scss';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { getGameGenre } from '@/pages/opinion/services';
import GenreSelect from '../GenreSelect';
import { operateGenreStorage } from '../../utils/storage';

export default function PlatformGameList({
  onChange,
  ...otherProps
}: PlatformGameListType) {
  const [platformSelect, setPlatformSelect] = useState([]);

  const platformChange = (key: string, data: { [key: string]: any }) => {
    onChange?.(key, data);
    setPlatformSelect(data?.value?.platform || []);
  };
  const { formatOptionsMessage } = useLanguage();
  const [filterOptions, setFilterOptions] = useState<Array<any>>([]);

  useEffect(() => {
    getGameGenre({ source: 'iegg' }).then((data: any) => {
      const value = Array.isArray(data) ? data : [];
      const genreMap: {
        'en-US': { [key in string]: string };
        'zh-CN': { [key in string]: string };
      } = {
        'en-US': {},
        'zh-CN': {},
      };
      value.forEach(({ genre, genre_cn, sub_genre }: any) => {
        let key = genre?.toLocaleLowerCase?.();
        genreMap['en-US'][key] = genre;
        genreMap['zh-CN'][key] = genre_cn;
        if (sub_genre.length > 0) {
          sub_genre.forEach(({ genre, genre_cn }: any) => {
            let key1 = genre?.toLocaleLowerCase?.();
            genreMap['en-US'][key1] = genre;
            genreMap['zh-CN'][key1] = genre_cn;
          });
        }
      });
      operateGenreStorage(genreMap);
      setFilterOptions(value);
    });
  }, []);

  return (
    <div className="platform-game-list-wrapper">
      <PlatformSelect
        {...otherProps}
        onChange={platformChange}
        filterOptions={formatOptionsMessage(platformOptions)}
      ></PlatformSelect>
      <GenreSelect
        {...otherProps}
        onChange={onChange}
        filterOptions={filterOptions}
      ></GenreSelect>
      <GameListSelect
        {...otherProps}
        platformSelect={platformSelect}
        onChange={onChange}
      ></GameListSelect>
    </div>
  );
}
